import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-left",
  "use": "icon-left-usage",
  "viewBox": "0 0 996 1127",
  "content": "<symbol viewBox=\"0 0 996 1127\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-left\">\n<path d=\"M941.694 705.72C1043.11 444.495 1032.2 -38.28 620.021 2.69771C207.847 43.6755 15.9085 234.452 0.69564 533.72C-14.5172 832.988 295.482 1126.22 498.319 1126.22C715.677 1126.22 822.34 1013.14 941.694 705.72Z\" fill=\"#2A62DD\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol